var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svgContent)?_c('span',{staticClass:"base-icon overflow-visible",style:(_vm.iconStyle),domProps:{"innerHTML":_vm._s(_vm.svgContent)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }